module.exports = __webpack_public_path__ + "img/4_Lower-esophagus.df9fa0b9.png";